<template>
  <div class="course-info">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="140px"
      class="demo-ruleForm"
      v-if="formData"
    >
      <div class="sell-style">
        
        <!-- 求合作 -->
        <div class v-if="cooperation_options&&cooperation_options.length>0">
          <div class="">
            <div>
              <el-form-item label="求合作：">
            <el-checkbox v-for="(item,index) in cooperation_options" :key="index" v-model="item.default" @change="getCheck">{{item.form_control_name}}</el-checkbox>               
              </el-form-item>
            </div>
          </div>
        </div>
        <!-- 选择关联专题 -->
        <el-row class="mt20">
          <el-form-item label="关联专题：" class="l"></el-form-item>
          <div class="choose-Special l">
            <ul
              v-if="(Object.keys(topicSelection).length!=0)&&(ruleForm.topic_id)"
              style="margin-bottom:10px;"
            >
              <li class="item">
                <span class="ft18 blod" v-if="isEdit">{{topicSelection.topic_name}}</span>
                <span class="ft18 blod" v-else>{{topicSelection.topic_name}}</span>
                <i class="el-icon-delete ml10 blue" @click="delTopic()"></i>
              </li>
            </ul>
            <div class="add">
              <el-button type="primary" @click="chooseSpecial()">
               <i class="el-icon-plus"></i>选择专题</el-button>
            </div>
          </div>
        </el-row>
      </div>
      <!--商品信息-->
      <base-title :title="`商品信息`"></base-title>
      <!-- <el-button type="primary" @click="test()">测试</el-button> -->
      <div class="sell-style">
        <el-form-item label="售卖方式：">
          <span>支持单独售卖</span>
        </el-form-item>
        <div class="main-content">
          <el-form-item label="售卖设置：" prop="type">
            <el-radio-group v-model="ruleForm.course_sell_mode">
              <el-radio :label="1">付费</el-radio>
              <el-radio :label="2">免费</el-radio>
              <el-radio :label="3">锁定课程</el-radio>
            </el-radio-group>
          </el-form-item>

          <div v-if="ruleForm.course_sell_mode==1">
            <el-form-item label>
              <el-form-item label="商品价格" prop="course_sell_price">
                <el-input v-model="ruleForm.course_sell_price" class="w140" placeholder="请输入商品价格"></el-input>
              </el-form-item>
              <el-row class="mt20" style="padding-left:20px;" v-if="formData.course_mode==2">
                <span>允许试听五分钟：</span>
                <el-switch v-model="ruleForm.is_try"></el-switch>
              </el-row>
            </el-form-item>
          </div>
          <div v-if="ruleForm.course_sell_mode==3">
               <el-form-item label="默认信息：">
            <el-checkbox v-for="(item,index) in collect_options" :key="index" v-model="item.default" @change="getCheck">{{item.form_control_name}}</el-checkbox>               
              </el-form-item>
          </div>
        </div>
      </div>

      <!-- 上架设置 -->
      <base-title :title="`上架设置`" class="mt20"></base-title>

      <div class="sell-style">
        <el-form-item label="上架设置：" prop="state">
          <el-radio-group v-model="ruleForm.state">
            <el-radio :label="2" class="block mt10">立即上架</el-radio>
            <el-row class="mt20">
              <el-radio :label="1" class="iblock">定时上架</el-radio>
              <el-form-item label prop="published_at" class="iblock" v-if="ruleForm.state==1">
                <el-date-picker
                  v-model="ruleForm.published_at"
                  type="datetime"
                  placeholder="选择定时上架时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
            </el-row>
            <el-radio :label="3" class="block mt20">暂不上架</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>

    <!-- //选择专题的弹框 -->
    <el-dialog title="关联专题" :visible.sync="dialogSpecial" width="600px" center>
      <el-row>
          <el-button round type="primary" @click="newSpecialAdd()">新建专题</el-button>
        <el-input
          placeholder="输入专题名称搜索"
          v-model="search.special_name"
          style="width:300px;"
          class="input-with-select input-sea r"
        >
          <el-button slot="append" icon="el-icon-search" @click="seachList()"></el-button>
        </el-input>
      </el-row>

      <el-row class="mt20" v-loading="tableLoading">
        <el-table
          ref="singleTable"
          :data="tableData"
          highlight-current-row
          tooltip-effect="dark"
          style="width: 100%"
          height="250"
          @current-change="handleSelectionChange"
        >
          <el-table-column label="专题名称" prop="topic_name">
          </el-table-column>
          <el-table-column label="状态" width="120">
            <template slot-scope="scope">
              <span v-show="scope.row.state==-1">删除</span>
              <span v-show="scope.row.state==1">定时上架</span>
              <span v-show="scope.row.state==2">已上架</span>
              <span v-show="scope.row.state==3">已下架</span>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSpecial = false">取 消</el-button>
        <el-button type="primary" @click="sendSpecial()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//标题组件
import Title from "../play-template/title";
//
import {
  //专题的列表
  _getTopicList,
  _topicSingleinfo
} from "@/api/topic";

import {
  //控件管理
  _formControlList
} from "@/api/user";
import { constants } from 'crypto';

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: {}
    }
  },
  components: {
    "base-title": Title
  },
  created() {
    // this.getTopicList();
  },
  watch: {
    formData(val) {
      for (let i in this.ruleForm) {
        this.ruleForm[i] = this.formData[i];
      }
      if (this.isEdit) {
        this.ruleForm.is_try == 1
          ? (this.ruleForm.is_try = true)
          : (this.ruleForm.is_try = false);
        //获取关联的专题信息
        if (this.formData && this.formData.topic_id) {
          this.topicSingleinfo(this.formData.topic_id);
        }
      }
      //加载控件的信息的操作
      this.formControlList();
    }
  },
  data() {
     const published_at = (rule, value, callback) => {
      if (new Date(value) < new Date()) {
        callback(new Error('开始时间必须大于当前时间'))
      } else if(!value){
        callback(new Error('请选择开始时间'))
      }else{
        callback();
      }
    }
    return {
      tableLoading: false,
      //选择专题弹框
      dialogSpecial: false,
      //一个状态来显示数据
      search: {
        special_name: ""
      },
      collect_options: [], //售卖方式信息
      cooperation_options: [], //求合作方式信息
      in_city: false,
      tableData: [],
      rele_special: [], //关联项目
      theChooseSpec:{},// 关联的专题的状态选择
      topicSelection: {}, //关联的专题暂存空间
      ruleForm: {
        is_try: true, //是否可以试听5分钟
        course_sell_price: "", //价格
        course_sell_mode: 2, //售卖方式
        state: 1, //上架设置
        published_at: "", //上架时间
        // home_page_banner: true,
        topic_id: "", //单个关联的id,
        collect_form: [], //售卖方式的控件信息
        cooperation_form: [] //求合作的控件信息
      },
      rules: {
        course_sell_price: [
          { required: true, message: "请输入商品价格", trigger: "blur" }
        ],
        state: [
          { required: true, message: "请选择上架设置", trigger: "change" }
        ],
        course_sell_mode: [
          { required: true, message: "请选择售卖方式", trigger: "change" }
        ],
        special: [
          {
            required: true,
            message: "请添加课程",
            trigger: "change"
          }
        ],
        published_at: [
          {
            // validator: published_at, 
            required: true,
            message: "请选择定时上架时间",         
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    //测试数据
    getCheck(val){
      console.log(val);
    },
    //删除默认信息的项目
    delDefInfo(item, index) {
      this.def_data.splice(index, 1);
      this.ruleForm.default_info[item] = "";
    },
    //选择主题的按钮
    chooseSpecial() {
      this.getTopicList();
      this.dialogSpecial = true;
    },
    //选择表格时候触发的事件
    handleSelectionChange(row) {
      this.theChooseSpec=row;
    },
    //确定关联专题
    sendSpecial() {
      this.topicSelection =this.theChooseSpec;
      // console.log(this.topicSelection);
      this.ruleForm.topic_id = this.topicSelection.topic_id;
      // console.log(this.ruleForm.topic_id);
      this.dialogSpecial = false;
    },
    //删除关联数据
    delTopic() {
      this.opicSelection = {};
      this.ruleForm.topic_id = "";
    },
    //查询专题
    seachList() {
      this.getTopicList();
    },
    //新建专题
    newSpecialAdd(){
      let page=this.$router.resolve({
        path:'/course/specialadd'
      })
      window.open(page.href,'_blank')
    },
    //获取单个的专题信息
    topicSingleinfo(topic_id){
        _topicSingleinfo({
          params: {
            topic_id:topic_id
          }
        }).then(res => {
          if (res.resultCode == 1) {
            this.topicSelection=res.result
          } else {
            this.$message.error(res.errorMsg);
          }})
    },
    //获取等待的列表
    getTopicList() {
      this.tableLoading=true;
        _getTopicList({
          params: {
            keywords: this.search.special_name
          }
        }).then(res => {
          this.tableLoading = false;
          if (res.resultCode == 1) {
            //添加一个单选功能属性来控制
            let data = res.result.list;
            this.tableData = data;
            // console.log(this.tableData);
          } else {
            this.$message.error(res.errorMsg);
          }
        });
    },
    //获取所有控件的信息
    formControlList() {
      _formControlList({
        params: {}
      }).then(res => {
        if (res.resultCode == 1) {
          //添加一个checkout的选中的默认状态，默认补选中
          let data = res.result;
          data.map(item => {
             item.default=false
              return item;
          });
          // console.log(data);
          //如果不是编辑的时候（添加的时候），添加两个参数来暂时存放值
          if (!this.isEdit) {
            this.collect_options = this.deepCopy(data);
            this.cooperation_options =this.deepCopy(data);
          } else {
            this.collect_options = this.getEditData(
              this.ruleForm.collect_form,
               this.deepCopy(data)
            );
            this.cooperation_options = this.getEditData(
              this.ruleForm.cooperation_form,
               this.deepCopy(data)
            );
          }
          //添加一个单选功能属性来控制
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    // 一个处理控件信息的方法
    getFormId(arr) {
      let data = [];
      arr.map(item => {
        if (item.default == true) {
          data.push(item.form_control_id);
        }
      });
      return data;
    },
     //first--编辑的的id，second所有的数据
    getEditData(first, second) {
      first.forEach(item => {
        second.map((info, index) => {
          if (info.form_control_id == item) {
            info.default=true
          }
        });
      });
      return second;
    },
    //深拷贝数据(数组)
    deepCopy(data){
      return JSON.parse(JSON.stringify(data));
    },
    //提交验证
    submitForm(formName) {
      let status;
      this.$refs[formName].validate(valid => {
        if (valid) {
          //处理子组件数据
          //如果不是付费模式的话，清除价格上传
          //如果不是锁定课程的话，清除锁定课程的数据
          //如果不是定时上架的话，清除定时时间
          if (this.ruleForm.course_sell_mode != 1) {
            delete this.ruleForm.course_sell_price;
          } else if (this.ruleForm.course_sell_mode != 3) {
            this.ruleForm.collect_form = [];
          }else if(this.ruleForm.state != 1){
            delete this.ruleForm.published_at
          }
          //添加控件的信息id数据（锁定课程和求合作）
          this.ruleForm.collect_form = this.getFormId(this.collect_options);
          this.ruleForm.cooperation_form = this.getFormId(
            this.cooperation_options
          );
          status = true;
        } else {
          status = false;
          console.log("error submit!!");
          return false;
        }
      });
      return status;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.course-info {
  .sell-style {
    // padding-left: 20px;
  }
  .main-content {
    overflow: hidden;
    width: 100%;
    background: #f5f7fa;
    padding-top: 10px;
    .space {
      margin: 14px 0;
      width: 95%;
      height: 2px;
      background: #efefef;
    }
    .add-info {
      // background: #d6d6d6;
      padding: 20px 0;
    }
  }
  .choose-Special {
    .item {
      margin-top: 10px;
      width: 300px;
      overflow: hidden;
      display: flex;
      span {
        flex: 7;
        overflow: hidden;
        margin-right: 20px;
      }
      i {
        flex: 2;
      }
    }
  }
  i {
    cursor: pointer;
  }
}
</style>